module.exports = __webpack_public_path__ + "static/img/fefco201_2.4d6eec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco201_2.png
// module id = a5Sr
// module chunks = 0